import { arrayOf, bool, func, node, shape, string } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { dismiss } from './actions';
import FlashMessage from './FlashMessage';

function FlashMessageContainer({ messages, onDismiss }) {
  return (
    <div className="fixed-bottom mx-2 d-inline-flex flex-column c-flash-message-container">
      <div>
        {messages.map(ea => (
          <FlashMessage
            key={ea.id}
            {...ea}
            onDismiss={onDismiss.bind(null, ea.id)}
          />
        ))}
      </div>
    </div>
  );
}
FlashMessageContainer.propTypes = {
  messages: arrayOf(
    shape({
      message: node.isRequired,
      color: string.isRequired,
      hidden: bool,
    }).isRequired,
  ).isRequired,
  onDismiss: func.isRequired,
};

export default connect(state => ({ messages: state.flashMessages }), {
  onDismiss: dismiss,
})(FlashMessageContainer);
export { FlashMessageContainer }; // for unit tests
